import financeModelsApiService from '@/services/api/FinanceModels'

const emptyModel = {
  id: null,
  label: null,
  type: null,
  parameters: {},
  income_safety_factor: null,
  yearly_income_factors: [],
  note: null,
  institution_name: null,
  country_id: null
}

const emptyFilters = {
  country_id: null,
  type: null
}

export default class FinanceModel {
  static api = financeModelsApiService
  static emptyModel = emptyModel
  static emptyFilters = emptyFilters
}
